import { render, staticRenderFns } from "./TheTitlebar.vue?vue&type=template&id=5f1d9e6c&scoped=true&"
import script from "./TheTitlebar.vue?vue&type=script&lang=js&"
export * from "./TheTitlebar.vue?vue&type=script&lang=js&"
import style0 from "./TheTitlebar.vue?vue&type=style&index=0&id=5f1d9e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d9e6c",
  null
  
)

export default component.exports